// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-link-dark[data-v-1b2797da] {
  justify-content: space-between;
  gap: 20px;
}
.btn-link-dark i[data-v-1b2797da] {
  padding-right: 20px;
}`, "",{"version":3,"sources":["webpack://./src/js/vue/components/MenuVehicle.vue","webpack://./MenuVehicle.vue"],"names":[],"mappings":"AACA;EACE,8BAAA;EACA,SAAA;ACAF;ADCE;EACE,mBAAA;ACCJ","sourcesContent":["\r\n.btn-link-dark {\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  i {\r\n    padding-right: 20px;\r\n  }\r\n}\r\n",".btn-link-dark {\n  justify-content: space-between;\n  gap: 20px;\n}\n.btn-link-dark i {\n  padding-right: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
